import React, { useState, useEffect } from 'react';
//TODO: Special colour to indicate that train WTB bus connection to a car is lost
import { invalid as invalidColor ,warning as warningColor,disabled as disabledColor } from '../../../styles/colors';

export const getColor = car => {
    if(car.alarms && car.alarms.length > 0) {
      return invalidColor;
    }
    if(car.faults && car.faults.length > 0) {
      return warningColor;
    }
    return '';
};

const StatusInfo = ({children, bgcolor}) => {
  return (
    <div style={{backgroundColor: bgcolor}}>
      {children}
    </div>
  )
};


const CarInfo = ({ car,consist }) => {
   const { alarms, warnings } = car;
   const bgcolor = getColor(car);
   return (
        <li key={consist +""+ car.carNumber} className="new-fleet-info__train__cars--list__item" >
            <StatusInfo bgcolor={bgcolor} className="new-fleet-info__train__cars--list__item--rect" >
              <span className="new-fleet-info__train__cars--list__item--rect__title">{car.carNumber}</span>
            </StatusInfo>
            <div className="new-fleet-info__train__cars--list__item__wheel-one"></div>
            <div className="new-fleet-info__train__cars--list__item__wheel-two"></div>
            <div className="new-fleet-info__train__cars--list__item__wheel-three"></div>
            <div className="new-fleet-info__train__cars--list__item__wheel-four"></div>
        </li>
    )
}
export default CarInfo